import { NgModule } from '@angular/core';
import { AuthRoutingModule } from './auth-routing.module';
import { SharedModule } from '../shared/shared.module';
import { AuthComponent } from './root-auth/auth.component';
import { LoginComponent } from './login/login.component';
import { SignupTypeComponent } from './signup-type/signup-type.component';
import { ResetComponent } from './reset/reset.component';
import { SignupComponent } from './signup/signup.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { OtpVerifyComponent } from './otp-verify/otp-verify.component';
import { ChangePasswordComponent } from './change-password/change-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { VerifyMobileComponent } from './verify-mobile/verify-mobile.component';
import { InvalidInvitationComponent } from './invalid-invitation/invalid-invitation.component';

@NgModule({
  declarations: [
    AuthComponent,
    LoginComponent,
    SignupTypeComponent,
    ResetComponent,
    SignupComponent,
    OtpVerifyComponent,
    ChangePasswordComponent,
    VerifyEmailComponent,
    VerifyMobileComponent,
    InvalidInvitationComponent,
  ],
  imports: [AuthRoutingModule, SharedModule, FormsModule, ReactiveFormsModule],
  providers: [],
})
export class AuthModule {}
